export function escapeHTML(str) {
  return new Option(str).innerHTML;
}
export function nl2br(str) {
  return str.split(/\n/).join("<br />");
}
